/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';
import {CommonService} from "../services/common.service";

@Pipe({ name: 'translateVorwerk'})
export class TranslateVorwerkPipe implements PipeTransform {


  constructor(private commonService: CommonService) {}

  transform(
    value: string,
  ): any {
    return this.commonService.getTranslatedVal(value);
  }
}
